export var TagType = /*#__PURE__*/function (TagType) {
  TagType[TagType["Unknown"] = 0] = "Unknown";
  TagType[TagType["Title"] = 1] = "Title";
  TagType[TagType["OwnerNick"] = 2] = "OwnerNick";
  TagType[TagType["Content"] = 3] = "Content";
  return TagType;
}({});
export var SEARCH_FILE_URL = "//".concat(location.host, "/v2/search/file");
export var ROOT_ID = '/';
//# sourceMappingURL=search-list.js.map